<template>
  <v-chip-group
    v-model="selection"
    active-class="primary--text text--accent-4"
    multiple
  >
    <v-chip
      v-for="week in weeks"
      :key="week.value"
      :value="week.value"
      color="white"
    >
      {{ week.text }}
    </v-chip>
  </v-chip-group>
</template>

<script>
export default {
  name: "WeekChips",
  props: {
    value: {
      type: [String],
      default: "",
    },
  },
  data() {
    return {
      weeks: [
        { text: "S", value: "Sunday" },
        { text: "M", value: "Monday" },
        { text: "T", value: "Tuesday" },
        { text: "W", value: "Wednesday" },
        { text: "T", value: "Thursday" },
        { text: "F", value: "Friday" },
        { text: "S", value: "Saturday" },
      ],
      sizes: ["S", "M", "T", "W", "T", "F", "S"],
    };
  },
  computed: {
    selection: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
  },
};
</script>

<style>
</style>